export const environment = {
  cliendId: '0ESMwITJu6HL59GKn7m4Z4OcSLGJP8qE',
  production: false,
  baseUrl: 'https://generic-gateway-us-central1-9u7gzl3z.uc.gateway.dev',
  authApiUrl: '/api/gateway/v1/auth',
  auth0_domain: "rentokil-initial-internal-dev.eu.auth0.com",
  region: "US",
  locale: 'en-US'

};


// Get clientId from GCP project OAuth2 credential path
// base url should be generic api gateway endpoint
// authApiUrl should be the auth rest end point from generic api gateway
